import template from './items.html';
import controller from './items.controller';
import './items.scss';

let printComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default printComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/items/print/items.component.js